import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgChevronRight = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M6.21 10.807a.62.62 0 0 1 0-.931L8.263 8 6.21 6.124a.62.62 0 0 1 0-.931.77.77 0 0 1 1.018 0l2.56 2.341a.62.62 0 0 1 0 .932l-2.56 2.341a.77.77 0 0 1-1.018 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
